var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6104 23.4375C31.7248 23.4386 31.8341 23.4845 31.915 23.5654C31.996 23.6464 32.0419 23.7556 32.043 23.8701C32.044 23.9847 31.9996 24.0953 31.9199 24.1777L27.6592 28.4404C27.6106 28.489 27.5527 28.5274 27.4893 28.5537C27.4256 28.5801 27.357 28.5938 27.2881 28.5938C27.2194 28.5937 27.1514 28.58 27.0879 28.5537C27.0561 28.5405 27.0256 28.5239 26.9971 28.5049L26.917 28.4404L24.8154 26.3379C24.7335 26.256 24.6877 26.1451 24.6875 26.0293C24.6875 25.9133 24.7334 25.8018 24.8154 25.7197C24.8973 25.6378 25.0082 25.5919 25.124 25.5918C25.24 25.5918 25.3516 25.6377 25.4336 25.7197L26.9795 27.2646L27.2881 27.5742L31.3027 23.5596C31.3852 23.4801 31.4959 23.4365 31.6104 23.4375Z",
    fill: "#595959",
    stroke: "#7A5AF8",
    strokeWidth: 0.874288
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3223 21.4952C24.4257 21.4952 26.9415 19.0321 26.9415 15.9937C26.9415 12.9553 24.4257 10.4922 21.3223 10.4922C18.2189 10.4922 15.7031 12.9553 15.7031 15.9937C15.7031 19.0321 18.2189 21.4952 21.3223 21.4952Z",
    stroke: "#7A5AF8",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9509 32.4899H13.7638C13.445 32.49 13.1299 32.4237 12.8394 32.2954C12.5488 32.1671 12.2894 31.9798 12.0785 31.7459C11.8675 31.512 11.7097 31.2368 11.6157 30.9386C11.5216 30.6404 11.4934 30.3261 11.533 30.0164L11.9713 26.5791C12.0732 25.7805 12.4696 25.0459 13.0859 24.5134C13.7023 23.9809 14.4961 23.6872 15.318 23.6875H15.7125",
    stroke: "#7A5AF8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/Assign-icon.793dbb9e16f7da8a93036bb66cd99a78.svg";
export { ForwardRef as ReactComponent };